define(() => {
    "use strict";

    return class DropdownOnChangeHandlers {
        constructor(options) {
            this.fixedValues = options.fixedValues;
            this.model = options.model;
        }

        _getChangedUser(newValues, previousValues) {
            const changedUser = newValues.find((user) => {
                const isNotPreviousUsers = !previousValues.some((previousValue) => previousValue.value === user.value);
                const isNotFixedValue = isNotPreviousUsers && !this.fixedValues.some((fixedValue) => fixedValue.value === user.value);
                return isNotFixedValue;
            });
            return changedUser.value;
        }

        onChangeHandler(newValues, previousValues) {
            if (newValues.length > previousValues.length) {
                const addUser = this._getChangedUser(newValues, previousValues);
                this.model.addSharedUser(addUser);
            } else {
                const removeUser = this._getChangedUser(previousValues, newValues);
                this.model.removeSharedUser(removeUser);
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/DropdownOnChangeHandlers.js